// Utility functions for handling URL parameters

export interface SurveyUrlParams {
  surveyGuid: string;
  respondentGuid?: string;
  isTest?: boolean;
}

export const getSurveyUrlParams = (): SurveyUrlParams | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const surveyGuid = urlParams.get('surveyGuid');
  const respondentGuid = urlParams.get('respondentGuid');
  const isTest = urlParams.get('isTest');
  
  if (!surveyGuid) {
    return null;
  }
  
  return {
    surveyGuid,
    respondentGuid: respondentGuid || undefined,
    isTest: isTest?.toLowerCase() === 'true',
  };
};

export const validateSurveyUrlParams = (): { isValid: boolean; error?: string } => {
  const params = getSurveyUrlParams();
  
  if (!params) {
    return {
      isValid: false,
      error: 'surveyGuid parameter is required in the URL'
    };
  }
  
  return { isValid: true };
};
